import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';

const AcknowledgeButton = ({ label, checked, onChange, className }) => {
  const buttonClasses = checked
    ? 'bg-blue-50 border-2 border-blue-600 text-blue-700'
    : 'bg-white border-2 border-slate-300 text-slate-700 hover:border-blue-400';

  const circleClasses = checked
    ? 'bg-blue-600 border-blue-600'
    : 'border-slate-400';

  return (
    <button
      type="button"
      className={`w-full px-6 py-3 rounded-lg font-medium text-base leading-[19.5px] transition-all duration-200 flex items-center justify-center gap-3 ${buttonClasses} ${className}`}
      onClick={() => onChange(!checked)}
    >
      <span
        className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${circleClasses}`}
      >
        {checked && <Check className="text-white" size={16} strokeWidth={3} />}
      </span>
      {label}
    </button>
  );
};

AcknowledgeButton.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

AcknowledgeButton.defaultProps = {
  className: '',
};

export default AcknowledgeButton;
